<script setup lang="ts">
import {computed, onMounted, ref, watch} from 'vue'
import MultiSelect from 'primevue/multiselect'
import { getYarnsList } from '@/api/yarns'
import type { Yarn } from '@/types/yarn-types'
import { useField, } from 'vee-validate'
import type { Product } from '@/types/product-types'

const props = defineProps<{
  modelValue?: any[]
  inputName: string
  disabled?: boolean
  quality?: Product
  options: Array<any>
}>()

const emit = defineEmits(['update:modelValue'])

const { value, errorMessage, handleBlur, handleChange } =
  useField<string[]>(props.inputName, [], {
    validateOnMount: false,
    validateOnValueUpdate: false
  });

const onBlur = (event: any ) => handleBlur(event.value);
const onChange = (event: { value: unknown }) => handleChange(event.value);

const allMerges = ref<Yarn[]>([]);
const availableMerges = ref<Yarn[]>([]);

onMounted(async () => {
  allMerges.value = await getYarnsList();
  filterMerges();

  if (props.modelValue) {
    value.value = props.modelValue.map(x => x.mergeNumber);
  }
})

const filterMerges = () => {
  if (props.quality && props.quality.yarnsUsed && props.quality.yarnsUsed.length > 0) {
    availableMerges.value = allMerges.value.filter(merge => {
      if (merge.kgAvailable <= 0) return false;

      return props.quality?.yarnsUsed.some(yarnUsed =>
          merge.yarnCount === yarnUsed.yarnCount.toString() &&
          merge.yarnColour === yarnUsed.yarnColour &&
          merge.yarnType === yarnUsed.yarnType
      );
    });
  } else {
    availableMerges.value = allMerges.value.filter(merge => merge.kgAvailable > 0);
  }
}

watch(() => props.quality, () => {
  filterMerges();
}, { deep: true });

watch(allMerges, () => {
  filterMerges();
})

const computedValue = computed({
  get: () => value.value,
  set: (newVal: string[] | undefined) => {
    if (newVal)
      value.value.splice(0, value.value.length, ...newVal);
    else
      value.value.splice(0, value.value.length);
    emit('update:modelValue', newVal)
  }
})

</script>

<template>
  <div class="flex flex-col gap-2">
    <label for="merge">Choose Merge:</label>
    <MultiSelect
      id="merge"
      v-model="computedValue"
      :options="availableMerges.map(yarn => yarn.mergeNumber)"
      :disabled="disabled"
      :invalid="!!errorMessage"
      @blur="onBlur"
      @change="onChange"
      aria-describedby="merge-help"
    />
    <small id="merge-help" class="italic">Available merge options are filtered based on Quality chosen.</small>
  </div>
</template>

<style scoped>

</style>